import { Th, Tooltip, Icon, Text, Box } from '@chakra-ui/react';
import { DUE_DATE_TOOLTIP } from '../constants/texts';
import { useIsTouchDevice } from '../hooks/useIsTouchDevice';

type Props = { columnName: string };

const TableHeader = ({ columnName }: Props): JSX.Element => {
  const isTouchDevice = useIsTouchDevice();

  return (
    <Th
      textTransform="none"
      fontSize={'1rem'}
      fontWeight={600}
      borderBottom={'1px solid'}
      borderColor={'#DFDEE2'}
      pr={3}
      pl={3}
      width={columnName === 'Cod. de Barras' ? '10px' : 'auto'}
    >
      <Box display={'flex'} flexDirection={'row'} gap={2} alignItems={'center'}>
        <Text>{columnName}</Text>
        {columnName === 'Vencimiento' && !isTouchDevice && (
          <Tooltip hasArrow label={DUE_DATE_TOOLTIP} bg={'#606060'} p={2}>
            <Icon boxSize={3.5} />
          </Tooltip>
        )}
      </Box>
    </Th>
  );
};

export default TableHeader;
